import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { SmallTicket } from 'helpers/svgs';
import s from 'components/bolt/fullScreenLoader/fullScreenLoader.sss';


export default class FullScreenLoader extends Component {

	render({ show }) {
		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<SmallTicket class={s.ticket} />
			</div>
		);
	}
}